import type { ComponentProps } from 'react'
import { useTranslations } from 'next-intl'
import { PasswordInput as AriaPasswordInput } from '@hello-aria/ui/password-input'

export type PasswordInputProps = Omit<ComponentProps<typeof AriaPasswordInput>, 'showLabel' | 'hideLabel'>

const PasswordInput = (props: PasswordInputProps) => {
    const t = useTranslations('root')

    return <AriaPasswordInput {...props} showLabel={t('passwordInput.show')} hideLabel={t('passwordInput.hide')} />
}

export default PasswordInput
